import type { Reducer } from 'redux';
import { Actions } from '@/redux/quizzes/actions';
import type { QuizzesState, QuizzesAction } from '@/redux/quizzes/types';

export const initialState = { available: 0 } as QuizzesState;

export default ((state = initialState, action: QuizzesAction) => {
  switch (action.type) {
    case Actions.SetQuizzesData:
      return { ...state, ...action.data };

    case Actions.SetQuizzesDataFail:
      return { ...state, error: action.error };

    default:
      return state;
  }
}) as Reducer<QuizzesState, QuizzesAction>;
